import { AxiosPromise } from 'axios';
import axios from 'axios';
import {
  IAwardCourseReq,
  IAwardModifyReq,
  IAwardReq,
  IGetAward,
  IGetAwardCourses,
  IGetAwardHistory,
  IGetAwards,
  IGetStudentAwards,
  IStudentAwardReq,
} from '../models/award.model';

const uri = '/mgmt/award';

export const getAwards = (): AxiosPromise<IGetAwards> => {
  return axios.get(uri);
};

export const getAward = (awardCode: string): AxiosPromise<IGetAward> => {
  return axios.get(`${uri}/${awardCode}`);
};

export const createAward = (data: IAwardReq): AxiosPromise => {
  return axios.post(uri, data);
};

export const updateAward = (
  awardCode: string,
  data: IAwardModifyReq,
): AxiosPromise => {
  return axios.put(`${uri}/${awardCode}`, data);
};

export const getAwardCourses = (
  awardCode: string,
): AxiosPromise<IGetAwardCourses> => {
  return axios.get(`${uri}/${awardCode}/course`);
};

export const createAwardCourses = (
  awardCode: string,
  data: IAwardCourseReq,
): AxiosPromise => {
  return axios.post(`${uri}/${awardCode}/course`, data);
};

export const updateAwardCourses = (
  awardCode: string,
  data: IAwardCourseReq,
): AxiosPromise => {
  return axios.put(`${uri}/${awardCode}/course`, data);
};

export const getStudentAwards = (
  classCode: string,
): AxiosPromise<IGetStudentAwards> => {
  return axios.get(`${uri}/${classCode}/student/list`);
};

export const createStudentAwards = (
  classCode: string,
  data: IStudentAwardReq[],
): AxiosPromise => {
  return axios.post(`${uri}/${classCode}/student`, data);
};

export const getAwardHistory = (
  memberCode: string,
  classCode: string,
): AxiosPromise<IGetAwardHistory> => {
  return axios.get(`${uri}/${memberCode}/student?classCode=${classCode}`);
};
